module.exports = __webpack_public_path__ + "img/ep5-6.8f095dc4.png";